import React, { Component } from 'react';
import _ from 'lodash';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  FooterBlock,
  Block,
  Button,
  NavBack,
} from 'components/landing/components';

import config from 'config/offer';
import './Offer.css';
import Header from './Header';
import SpecList from './SpecList';

const dumbOffer = dumbBem('l-offer');
const OfferWrp = tx(dumbOffer)('div');

export class Offer extends Component {
  constructor(props) {
    super(props);
    _.bindAll(this, ['apply', 'generateSpecItem']);
  }

  generateSpecItem(spec, id) {
    return { ...spec, bullets: this.props[spec.id] };
  }

  getItemsWithBullets(spec) {
    return spec.bullets;
  }

  formatSpecList() {
    return config.blocksSpec
      .map(this.generateSpecItem)
      .filter(this.getItemsWithBullets);
  }

  render() {
    const {
      title,
      locations,
      compensation,
      history: { goBack },
    } = this.props;
    const specList = this.formatSpecList();

    return (
      <OfferWrp>
        <NavBack onClick={goBack}>back</NavBack>

        <Header
          title={title}
          locations={locations}
          compensation={compensation}
          apply={this.apply}
        />

        <SpecList specList={specList} />

        <Block modifier="apply">
          <Button onClick={this.apply} modifier="reversed-colors">APPLY</Button>
        </Block>

        <FooterBlock />
      </OfferWrp>
    );
  }

  apply() {
    window.location.href = `mailto:careers@iteriodata.com?Subject=${this.props.title}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/offer/Offer.js